import PropTypes from 'prop-types';

import CheckboxInput from './CheckboxInput';
import DateInput from './DateInput';
import RadioInput from './RadioInput';
import TextInput from './TextInput';
import SelectInput from './SelectInput';
import TimeInput from './TimeInput';
import TextareaInput from './TextareaInput';
import NumberInput from './NumberInput';

const getInputComponent = (type, props) => {
  const components = {
    TEXT: <TextInput {...props} key={props.id} />,
    NUMBER: <NumberInput {...props} key={props.id} />,
    TEXTAREA: <TextareaInput {...props} key={props.id} />,
    MULTIPLE_CHOICE: <RadioInput {...props} key={props.id} />,
    CHECKBOX: <CheckboxInput {...props} key={props.id} />,
    DATE: <DateInput {...props} key={props.id} />,
    SELECT: <SelectInput {...props} key={props.id} />,
    TIME: <TimeInput {...props} key={props.id} />,
    TITLE: (
      <div className="input-wrapper" data-cy={props.id} key={props.id}>
        {props.title}
      </div>
    ),
  };
  return components[type] || null;
};

const SubForms = ({ id, setValue, forms, values, canEditPage, title }) => {
  return (
    <div className="sub-forms-wrapper" data-cy={id}>
      <label htmlFor={id}>{title}</label>
      {forms.map((item) => {
        return getInputComponent(item.type, {
          ...item,
          setValue: (data) => {
            const [[_, value]] = Object.entries(data);
            setValue({ [item.id]: value });
          },
          values: values || {},
          canEditPage,
        });
      })}
    </div>
  );
};

SubForms.propTypes = {
  setValue: PropTypes.func,
  title: PropTypes.string,
  forms: PropTypes.array,
  values: PropTypes.shape(),
  canEditPage: PropTypes.bool,
  id: PropTypes.string,
};

export default SubForms;
